<template>
  <div class="mobileBox">
    <div class="topBanner">
      <img class="bannerImg" src="../../../assets/img/homeBanner_m.png"/>


      <top-nav></top-nav>


      <div class="homeBannerText animated" :class="animates.mm6 ? 'fadeInUp' : 'hideBox'">
        <div class="logoBox"><img src="../../../assets/icon/Banner Main@2x.png"/></div>
        <div class="text1">Expand your business scope and payment.</div>
        <div class="bannerText3" style="overflow: visible;"  @click="navClick('/apply_m')"><span >CONTACT US</span></div>
      </div>
    </div>

    <div class="contentBox">
      <!--板块1-->
      <div class="index01" id="m1">
        <div class="index01_m animated" :class="animates.mm1 ? 'fadeInUp' : 'hideBox'">
          <div class="content_left_title">PAYMENT SOLUTIONS</div>
          <div class="tabsBox">
            <div class="tabsTitle">
              <span :class="act.tabsTitleId===1 ? 'act' : ''" @click="tabsTitleClick(1)">Instore</span>
              <span :class="act.tabsTitleId===2 ? 'act' : ''" @click="tabsTitleClick(2)">Online</span>
            </div>
            <div class="tabsContent">
              <ul v-if="act.tabsTitleId===1">
                <li class="iconLi" @mouseenter="enter1(1,1)" @mouseleave="leave1(1,0)">
                  <div v-show="show.shows1===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_instore1.png"/></div>
                    <div class="textDiv">Merchant QR Code</div>
                  </div>
                  <div v-show="show.ids1===1 && show.shows1===1" class="borderDiv border">
                    <div class="textTitle">Merchant QR Code</div>
                    <div class="textContent">Customers can scan the static QR code to make a payment. Customers are required to enter the price themselves.</div>
                  </div>
                </li>
                <li class="iconLi" @mouseenter="enter2(2,1)" @mouseleave="leave2(2,0)">
                  <div v-show="show.shows2===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_instore2.png"/></div>
                    <div class="textDiv">Smart Device</div>
                  </div>
                  <div v-show="show.ids2===2 && show.shows2===1" class="borderDiv border">
                    <div class="textTitle">Smart Device</div>
                    <div class="textContent">A smart device allows the merchant to create QR code for the customer to scan or to scan the customer's payment code.</div>
                  </div>
                </li>
                <li class="iconLi" @mouseenter="enter3(3,1)" @mouseleave="leave3(3,0)">
                  <div v-show="show.shows3===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_instore3.png"/></div>
                    <div class="textDiv">POS Integration</div>
                  </div>
                  <div v-show="show.ids3===3 && show.shows3===1" class="borderDiv border">
                    <div class="textTitle">POS Integration</div>
                    <div class="textContent">We can integrate SuperiorPay with existing POS terminals.</div>
                  </div>
                </li>
                <!--<li class="iconLi">-->
                  <!--<div class="borderDiv">-->
                    <!--<div class="btnDiv"  @click="navClick('/apply_m')">CONTACT US</div>-->
                  <!--</div>-->
                <!--</li>-->
                <li style="clear: both;"></li>
              </ul>
              <ul v-if="act.tabsTitleId===2">
                <li class="iconLi" @mouseenter="enter1(1,1)" @mouseleave="leave1(1,0)">
                  <div v-show="show.shows1===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_online1.png"/></div>
                    <div class="textDiv">3rd Party Gateway</div>
                  </div>
                  <div v-show="show.ids1===1 && show.shows1===1" class="borderDiv border">
                    <div class="textTitle">3rd Party Gateway</div>
                    <div class="textContent">Integrate Alipay and WeChat Pay with merchant’s website, consumers can scan the QR code to make payments.</div>
                  </div>
                </li>
                <li class="iconLi" @mouseenter="enter2(2,1)" @mouseleave="leave2(2,0)">
                  <div v-show="show.shows2===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_online2.png"/></div>
                    <div class="textDiv">H5 Gateway</div>
                  </div>
                  <div v-show="show.ids2===2 && show.shows2===1" class="borderDiv border">
                    <div class="textTitle">H5 Gateway</div>
                    <div class="textContent">Apply to mobile terminals, consumers pay on mobile websites or Apps, and then switch to Alipay/WeChat Pay to finish payments.</div>
                  </div>
                </li>
                <li class="iconLi" @mouseenter="enter3(3,1)" @mouseleave="leave3(3,0)">
                  <div  v-show="show.shows3===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_online3.png"/></div>
                    <div class="textDiv">SDK Gateway</div>
                  </div>
                  <div v-show="show.ids3===3 && show.shows3===1" class="borderDiv border">
                    <div class="textTitle">SDK Gateway</div>
                    <div class="textContent">Apply to mobile Apps, consumers can make payments in mobile App.</div>
                  </div>
                </li>
                <li class="iconLi" @mouseenter="enter4(4,1)" @mouseleave="leave4(4,0)">
                  <div v-show="show.shows4===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_online4.png"/></div>
                    <div class="textDiv">JSAPI Gateway</div>
                  </div>
                  <div v-show="show.ids4===4 && show.shows4===1" class="borderDiv border">
                    <div class="textTitle">JSAPI Gateway</div>
                    <div class="textContent">Apply to mini programs opened in Alipay/WeChat Pay, consumers can finish payments with in the mini programs.</div>
                  </div>
                </li>
                <li style="clear: both;"></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!--板块2-->
      <div class="index02" id="m2">
        <div class="index02_m animated" :class="animates.mm2 ? 'fadeInUp' : 'hideBox'">
          <div class="content_center_title">DID YOU KNOW?</div>
          <div class="contentBox">
            <div class="text1">China is the largest and most valuable inbound visitor market for Australia. In the year ending September2018, short- term Chinese visitors made 13 million trips to the country and delivered $11.5 billion to the Australia visitor economy.</div>
            <ul class="index02Ul">
              <li class="index02Li leftLi">
                <div class="div80">
                  <div class="title">Chinese Payment Systems</div>
                  <div class="content">According to a recent survey by lpsos, Third-Party Mobile Payment UsersResearch Report. It is estimated thatChina has more than 940 million active mobile payment users.</div>
                  <div class="btnDiv">
                    <div class="btn1" @click="linkDownload($baseUrl+'/static/digial_sales_kit.pdf')" >Learn More</div>
                    <div class="btn2" @click="navClick('/apply_m')">CONTACT US</div>
                  </div>
                </div>
              </li>
              <li class="index02Li centerLi">
                <div class="div80">
                  <div class="centerText">Share of Transaction<br/>Value<br/>by Payment Method</div>
                </div>
              </li>
              <li class="index02Li rightLi">
                <div class="div80">
                  <div class="rowBox">
                    <img src="../../../assets/icon/home_index2_icon1.png"/>Instore mobile payment-41%
                  </div>
                  <div class="rowBox">
                    <img src="../../../assets/icon/home_index2_icon2.png"/>Online mobile payment-19%
                  </div>
                  <div class="rowBox">
                    <img src="../../../assets/icon/home_index2_icon3.png"/>Instore card payment-16%
                  </div>
                  <div class="rowBox">
                    <img src="../../../assets/icon/home_index2_icon4.png"/>Online card payment-14%
                  </div>
                  <div class="rowBox">
                    <img src="../../../assets/icon/home_index2_icon5.png"/>Others-16%
                  </div>
                </div>
              </li>
              <li style="clear: both;"></li>
            </ul>
          </div>
        </div>
      </div>

      <!--板块3-->
      <div class="index03" id="m3">
        <div class="index03_m animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">
          <div class="content_center_title">WHY SUPERIORPAY</div>
          <div class="contentBox">
            <ul>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon1.png"/></div>
                <div class="textDiv">Free sign-up at no extra charge</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon2.png"/></div>
                <div class="textDiv">No Alipay or WeChat Payaccount required from merchants</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon3.png"/></div>
                <div class="textDiv">'T+1' automatic settlement</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon4.png"/></div>
                <div class="textDiv">No trading volume limit for merchants</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon5.png"/></div>
                <div class="textDiv">Bank-grade financial security</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon6.png"/></div>
                <div class="textDiv">Web + App accountmanagement, real-time account monitoring</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon7.png"/></div>
                <div class="textDiv">Multi-platform marketing solutions</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon8.png"/></div>
                <div class="textDiv">24-hour customer services</div>
              </li>
            </ul>

          </div>
          <div style="clear: both"></div>
        </div>
      </div>

      <!--板块4-->
      <div class="index04" id="m4">
        <div class="index04_m animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">
          <div class="content_center_title">OUR CHANNELS</div>
          <div class="contentBox">SuperiorPay cooperates with Australia's local POS system providers, including Blueshyft, Futura, AuPos, IPOS,PosPal, and GVT, enabling system integration, settlement management, refund management etc., to ensure the customers have access to comprehensive cross- border payment services.</div>
          <div class="btn" @click="navClick('/apply_m')">CONTACT US</div>
          <ul class="logoUl">
            <li><img src="../../../assets/icon/home_index4_icon1.png"/></li>
            <li><img src="../../../assets/icon/home_index4_icon2.png"/></li>
            <li><img src="../../../assets/icon/home_index4_icon3.png"/></li>
            <!-- <li><img src="../../../assets/icon/home_index4_icon4.png"/></li> -->
            <li><img src="../../../assets/icon/home_index4_icon5.png"/></li>
            <li><img src="../../../assets/icon/home_index4_icon6.png"/></li>
          </ul>
        </div>
      </div>

      <!--板块5-->
      <div class="index05" id="m5">
        <div class="animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">


          <div class="swiper-container">
            <div class="swiper-wrapper index5Ul">
              <div class="swiper-slide index5Li">
                <div class="mapBox"><img src="../../../assets/img/home_map_img1.png"/></div>
                <div class="mapTitle">Sydney Office</div>
                <div class="mapContent">1753/9 Castlereagh St<br/> Capita Centre <br/>Sydney NSW 2000<!-- <br/> Phone:1300 066 006 --></div>
              </div>
              <div class="swiper-slide index5Li">
                <div class="mapBox"><img src="../../../assets/img/home_map_img2.png"/></div>
                <div class="mapTitle">Melbourne Office</div>
                <div class="mapContent">201, Level 2B<br/> 818 Whitehorse Rd<br/> Box Hill VIC 3128<!-- <br/> Phone: 1300 066 006 --></div>
              </div>
              <div class="swiper-slide index5Li">
                <div class="mapBox"><img src="../../../assets/img/home_map_img3.png"/></div>
                <div class="mapTitle">Adelaide Office</div>
                <div class="mapContent">177 Gilbert street, Adelaide<br/> SA 5000 <!-- <br/>Phone: 1300 066 006 --></div>
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination"></div>
            <!-- 如果需要导航按钮 -->
            <!--<div class="swiper-button-prev"></div>-->
            <!--<div class="swiper-button-next"></div>-->
            <!-- 如果需要滚动条 -->
            <!--<div class="swiper-scrollbar"></div>-->
          </div>

        </div>
      </div>

      <!--底部-->
      <div class="footer_m ">
        <div class="footer_mText">
          Supay Technology Pty Ltd. Authorized Representative Number 001283947
          <div class="goTopBtn" @click="toTop"><img src="../../../assets/icon/goTopIcon.png"/></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  import topNav from './nav_m'
  let timer = null; //定义初始值
    export default {
      components:{topNav},
      name: "home_m",
      props:{
        step:{   //此数据是控制动画快慢的
          type:Number,
          default:50
        }
      },
      data(){
          return{
            act:{
              tabsTitleId:1,
            },
            show:{
              ids1:0,
              shows1:0,
              ids2:0,
              shows2:0,
              ids3:0,
              shows3:0,
              ids4:0,
              shows4:0,
            },
            animates:{
              mm1:false,
              mm2:false,
              mm3:false,
              mm4:false,
              mm5:false,
              mm6:false,
            },
          }
      },
      destroyed(){
        window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
      },
      mounted () {
        document.documentElement.scrollTop=0;

        new Swiper('.swiper-container', {
          loop:true,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          pagination:{
            el:".swiper-pagination",
            clickable:true,
          },
          // navigation:{
          //   prevEl:".swiper-button-prev",
          //   nextEl:".swiper-button-next",
          // }
        });


        this.animates.mm1 = true;
        this.animates.mm6 = true;
        window.addEventListener('scroll', this.handleScroll)




      },

      methods:{
        //鼠标滑动动画
        handleScroll () {
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

          var offsetTop1 = document.querySelector('#m1').offsetTop;
          var offsetTop2 = document.querySelector('#m2').offsetTop;
          var offsetTop3 = document.querySelector('#m3').offsetTop;
          var offsetTop4 = document.querySelector('#m4').offsetTop;
          var offsetTop5 = document.querySelector('#m5').offsetTop;


          if (scrollTop > offsetTop1-800) {
            this.animates.mm1 = true
          } else {
            this.animates.mm1 = false
          }
          if (scrollTop > offsetTop2-800) {
            this.animates.mm2 = true
          } else {
            this.animates.mm2 = false
          }
          if (scrollTop > offsetTop3-800) {
            this.animates.mm3 = true
          } else {
            this.animates.mm3 = false
          }
          if (scrollTop > offsetTop4-800) {
            this.animates.mm4 = true
          } else {
            this.animates.mm4 = false
          }
          if (scrollTop > offsetTop5-800) {
            this.animates.mm5 = true
          } else {
            this.animates.mm5 = false
          }
        },

        //  点击导航
        navClick(url){
          this.$router.push(url);
        },//打开新连接
        linkDownload (url) {
          window.open(url,'_blank') // 新窗口打开外链接
        },
        
        //  tabs切换
        tabsTitleClick(index){
          this.act.tabsTitleId=index;
        },
        //  板块1鼠标移入移出
        enter1(id,show){
          this.show.ids1 = id;
          this.show.shows1 = show;
        },
        leave1(id,show){
          this.show.ids1 = id;
          this.show.shows1 = show;
        },
        enter2(id,show){
          this.show.ids2 = id;
          this.show.shows2 = show;
        },
        leave2(id,show){
          this.show.ids2 = id;
          this.show.shows2 = show;
        },
        enter3(id,show){
          this.show.ids3 = id;
          this.show.shows3 = show;
        },
        leave3(id,show){
          this.show.ids3 = id;
          this.show.shows3 = show;
        },
        enter4(id,show){
          this.show.ids4 = id;
          this.show.shows4 = show;
        },
        leave4(id,show){
          this.show.ids4 = id;
          this.show.shows4 = show;
        },
        //置顶
        toTop(){ // 动画

          timer = setInterval(function () {
            let osTop = document.documentElement.scrollTop || document.body.scrollTop;
            let ispeed = Math.floor(-osTop / 5);
            document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
            // this.isTop = true
            if (osTop === 0) {
              clearInterval(timer)
            }
          },30)

        },

      }



    }
</script>

<style scoped>
  .index05 .swiper-container {
    width: 100%;
    height: auto;
    padding-bottom: 70px;
  }



  .mobileBox{width: 100%;height: auto;}
  .mobileBox .topBanner{width: 100%;height: auto;position: relative;}
  .mobileBox .topBanner .bannerImg{width: 100%;height: auto;}


  .topBanner .homeBannerText{position: absolute;top: 34%;width: 100%;height: auto;}
  .topBanner .homeBannerText .logoBox{width: 100%;height: 30px;text-align: center;}
  .topBanner .homeBannerText .logoBox>img{width: 7.75rem;height: 1.625rem;}
  .topBanner .homeBannerText .text1{width: 80%;padding: 3rem 10%; font-size: 1rem;color: #fff;text-align: center;height: 22%;font-family: MontserratRegular;}
  .topBanner .homeBannerText .bannerText3{font-size: 17px;color: rgba(255,255,255,0.6);text-align: center;cursor: pointer;margin-top: 5%;}
  .topBanner .homeBannerText .bannerText3>span{width: 95px;height: 35px;line-height: 35px;display: inline-block; border: 1px solid rgba(255,255,255,0.6);font-family: MontserratMedium;}
  .topBanner .homeBannerText .bannerText3>span:hover{color: #fff;border: 1px solid #fff;transition: all 0.5s ease-in-out;}



  .content_left_title{font-size: 1rem;color: #4a4a4a;height: 5rem;line-height: 5rem;width: calc(100% - 30px);font-family:OpenSans600;padding: 0 15px;}
  .content_center_title{font-size: 1.5rem;color: #4a4a4a;height: 5rem;line-height: 5rem;width: 100%;text-align: center;font-family: OpenSans300;font-weight:300;}


  /*板块1*/
  .index01{height: auto;background-color: #fff;padding:2rem 15px;}
  .index01 .tabsBox{width: 100%;height: auto;}
  .index01 .tabsBox .tabsTitle{width: calc(100% - 30px);margin: auto; height: 2rem;line-height: 2rem; border-bottom: 1px solid #dbdbdb;font-family: MontserratMedium;}
  .index01 .tabsBox .tabsTitle>span{font-size: 1rem;color: #4a4a4a;padding:0 0.7rem;display: inline-block;margin-right: 1rem;cursor: pointer;}
  .index01 .tabsBox .tabsTitle>span.act{border-bottom: 2px solid #f05423;}
  .index01 .tabsBox .tabsContent{width: 100%;height: auto;}
  .index01 .tabsBox .tabsContent>ul{width: 100%;height: 100%;margin-top: 5px;}
  .index01 .tabsBox .tabsContent>ul .iconLi{width: calc(50% - 0.35rem);height: 10rem;float: left;cursor: pointer;border: 1px solid rgba(0,0,0,0);margin-top: 15px;
    box-shadow:
      -2px 0 7px -1px #dadada,
      0 -2px 0px -1px rgba(0,0,0,0),
      0 2px 7px -1px #dadada,
      2px 0 7px -1px #dadada;
  }

  .index01 .tabsBox .tabsContent>ul .iconLi:nth-of-type(even){float: right;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv{width: 100%;height: calc(100% - 2px);padding: 1.5rem 0;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv.border{padding: 0;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv .iconDiv{width: 100%;text-align: center;margin-top: 0rem;margin-bottom: 0rem;height: 6rem;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv .iconDiv>img{transform: scale(0.7);}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv .textDiv{width: 100%;text-align: center;font-size: 0.65rem;color: #4a4a4a;font-family: MontserratMedium;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv .btnDiv{margin:6.5rem auto; color: #fff;font-size: 0.97rem;background-color: #083358;font-family: MontserratMedium;width: 8rem;text-align: center;border-radius: 4px; height: 2.5rem;line-height: 2.5rem;cursor: pointer;}


  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv.border .textTitle{width: 100%;margin:auto; font-family: MontserratMedium;font-size: 0.9rem;color: #4a4a4a;text-align: center;line-height: 2rem;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv.border .textContent{width: 100%;margin: auto;font-family: Montserrat300;font-size: 0.75rem;color: #515151;text-align: center;line-height: 1.2rem;}

  /*板块2*/
  .index02{height: auto;background-color: #f6f6f6;padding: 2rem 0;}
  .index02 .contentBox{width: 100%;height: auto;}
  .index02 .contentBox .text1{width: 90%;font-size: 0.875rem;font-family:Montserrat300; color: #4a4a4a;text-align: center;margin: auto;line-height: 1.5rem;height: auto;}
  .index02 .contentBox .index02Ul{width: 100%;height: auto;margin-top: 3rem;}
  .index02 .contentBox .index02Ul .index02Li{float: left;width: 100%;height: 100%;overflow: hidden;margin-bottom: 3rem;}
  .index02 .contentBox .index02Ul .index02Li:nth-of-type(3){margin-bottom: 0rem;}
  .index02 .contentBox .index02Ul .index02Li.leftLi{}
  .index02 .contentBox .index02Ul .index02Li.leftLi .div80{width: 17rem;height: 100%; margin: auto;}
  .index02 .contentBox .index02Ul .index02Li.leftLi .title{font-size: 1rem;font-family: Montserrat600; color: #4a4a4a;text-align: center;line-height: 2.5rem;}
  .index02 .contentBox .index02Ul .index02Li.leftLi .content{font-size: 0.875rem;color: #4a4a4a;font-family:Montserrat300;  text-align: center;line-height: 1.5rem;margin-top: 1rem;}
  .index02 .contentBox .index02Ul .index02Li.leftLi .btnDiv{width: 100%;height:2.5rem;margin-top: 2rem; }
  .index02 .contentBox .index02Ul .index02Li.leftLi .btnDiv .btn1{font-family: MontserratMedium; width: 6.875rem;line-height: 2.5rem;text-align: center;font-size: 0.93rem;float: left;color: #4a4a4a;border: 1px solid #4a4a4a;border-radius: 4px;font-weight: 500;cursor: pointer;}
  .index02 .contentBox .index02Ul .index02Li.leftLi .btnDiv .btn2{font-family: MontserratMedium;width: 6.875rem;line-height: 2.5rem;text-align: center;font-size: 0.93rem;float: right;color: #fff;border: 1px solid #083358;background-color: #083358; border-radius: 4px;font-weight: 500;cursor: pointer;}
  .index02 .contentBox .index02Ul .index02Li.centerLi .div80{background: url("../../../assets/icon/home_index2_yuan.png") no-repeat center center;width: 17rem;height: 17rem;display: flex;align-items: center;background-size: 100% 100%;margin: auto;}
  .index02 .contentBox .index02Ul .index02Li.centerLi .centerText{font-family:Montserrat300;width:100%;height: 3.9rem;align-items: center;text-align: center;font-size: 0.875rem;color: #4a4a4a;line-height: 1.3rem;}
  .index02 .contentBox .index02Ul .index02Li.rightLi .div80{width: 19rem;height: 100%; margin: auto;}
  .index02 .contentBox .index02Ul .index02Li.rightLi .rowBox{font-family:Montserrat300;font-size: 0.875rem;color: #4a4a4a;display: flex;align-items: center;margin-bottom: 2rem;}
  .index02 .contentBox .index02Ul .index02Li.rightLi .rowBox>img{margin-right: 1rem;}

  /*板块3*/
  .index03{height: auto;background-color: #fff;padding: 2rem 0;}
  .index03 .contentBox{width: 90%;height: auto;padding: 0 5%;float: left;}
  .index03 .contentBox>ul{width: 100%;height: auto;}
  .index03 .contentBox>ul>li{float: left;width:calc(50% - 5px);height: 12rem;padding: 0; }
  .index03 .contentBox>ul>li:nth-of-type(even){float: right;}
  .index03 .contentBox>ul>li .iconDiv{width: 100%;height: 6rem;text-align: center;margin-top: 1rem;display: flex;align-items: center;}
  .index03 .contentBox>ul>li .iconDiv>img{align-items: center;margin: auto;}
  .index03 .contentBox>ul>li .textDiv{width: 100%;font-size: 14px;word-wrap:break-word;color: #6d7278;text-align: center;line-height: 1.3rem;font-family: MontserratMedium;}

  /*板块4*/
  .index04{height: auto;background-color: #181818;padding: 4rem 0;}
  .index04 .content_center_title{color: #fff;}
  .index04 .contentBox{width: 80%;margin:2rem auto;color: #fff;font-size: 0.875rem;text-align: center;line-height: 1.5rem;font-family:Montserrat300;}
  .index04 .btn{width: 6.875rem;line-height: 2.5rem;margin: 4rem auto;font-size: 0.875rem;color: rgba(255,255,255,0.6);cursor: pointer; border: 1px solid rgba(255,255,255,0.6);border-radius: 4px;text-align: center;font-family: MontserratMedium;}
  .index04 .btn:hover{color: #fff;border-color: #fff;transition: all 0.5s ease-in-out; }
  .index04 .logoUl{width: 100%;height:auto;}
  .index04 .logoUl>li{width: 100%;height: 5rem;display: flex;align-items: center;}
  .index04 .logoUl>li>img{align-items: center;margin: auto;}


  /*板块5*/
  .index05{height: auto;background-color: #f6f6f6;padding: 45px 0;}
  .index05 .index5Ul{width: 100%;height: auto;}
  .index05 .index5Ul .index5Li{width: 100%;height: 100%;}
  .index05 .index5Ul .index5Li .mapBox{width: 19rem;height: 19rem;border-radius: 50%;display: flex;align-items: center;overflow: hidden;margin: auto;}
  .index05 .index5Ul .index5Li .mapBox>img{align-items: center;margin: auto;}
  .index05 .index5Ul .index5Li .mapTitle{width: 17rem;height: 3rem;line-height: 3rem;margin: auto; font-family:OpenSans600;text-align: center;font-size: 0.875rem;color: #515151;}
  .index05 .index5Ul .index5Li .mapContent{width: 13rem;height: auto; line-height: 1.5rem;margin: auto; font-family:Montserrat300;text-align: center;font-size: 0.875rem;color: #515151;}


  .hideBox{display: none;}

</style>
